import { AccountTypes } from "@utils";
import { SubmitLimitAction } from "@state/stores/account-settings/my-limits/MyLimitsStore";

export class ResolveLimit {
	amount: number;
	action: number;
	categoryAbrv: string;
	durationAbrv: string;
	gamingLimitTypeAbrv: string;
	limitId: string;
}

export class ResolveDepositAndLossLimit {
	//deposit
	amount: number;
	gamingLimitAction: SubmitLimitAction;
	gamingLimitCategoryAbrv: string;
	gamingLimitDurationAbrv: string;
	gamingLimitTypeAbrv: string;
	limitId: string | null;

	//loss
	lossAmount: number;
	lossGamingLimitAction: SubmitLimitAction;
	lossGamingLimitCategoryAbrv: string;
	lossGamingLimitDurationAbrv: string;
	lossGamingLimitTypeAbrv: string;
	lossLimitId: string | null;

	activeGamingLimitCategoryAbrv: string;
	consents?: LimitIncreaseConsent[];
}

export type LimitIncreaseConsent = {
	consentContent: string;
	hasConsented: boolean;
};

export class ResolveLimitRequest {
	action: number;
	categoryAbrv: string;
	userLimitId: string;
	userLimitRequestId: string;
}

export class LimitCategoriesViewModel {
	categoryId: string;
	categoryName: string;
	maxAmount: number;
	minAmount: number;
	description: string[];
	durations: UserLimit[];
	isMultiLimitModeEnabled: boolean;
	requests: LimitRequest[];
	infoMessage?: string | null;
	currency: string;
	isMultiTypeMode: boolean;
	activeCategoryAbrv: string;
	updateInterval: number;
}

export class UserLimit {
	limitId: string;
	name: string;
	canBeUpdated: boolean;
	canBeDeleted: boolean;
	units: number;
	amount: number | null;
	categoryAbrv: string;
	gamingLimitTypeAbrv: string;
	gamingLimitTypeName: string;
	maxValue: number;
	abrv: string;
	durationId: string;
	cooldownDate: string | null;
}

export class LimitRequest {
	requestType: string;
	limitType: string;
	requestedAmount: number;
	currentAmount: number;
	categoryId: string;
	requestDate: string;
	expirationDate: string;
	limitId: string;
	requestId: string;
	limitInterval?: string;
	hasLimitAmountChanged?: boolean;
	hasLimitTypeChanged?: boolean;
	hasLimitDurationChanged?: boolean;
	isDeactivation?: boolean;
	name: string;
	categoryAbrv: string;
	gamingLimitTypeAbrv: string;
}

export class LimitSubmit {
	amount: number;
}

export type DepositAndLossLimitSubmit = LimitSubmit & {
	lossAmount: number;
	consentGdpr?: boolean;
	consentGgl?: boolean;
	consentCreditCheck?: boolean;
};

export type DepositLimitFormType = LimitSubmit | DepositAndLossLimitSubmit;

export class TabModel {
	id: string;
	name: string;
	accountType: AccountTypes;
}

export type LimitTypeItem = {
	abrv: string;
	dateCreated: string;
	dateUpdated: string;
	description?: string;
	id: string;
	name: string;
};

export type TLimitDurationItem = LimitTypeItem & {
	units: number;
};

export class SubmitSingleLimitData {
	amount: number;
	limitDurationAbrv: string;
	gamingLimitTypeAbrv: string;
}

export enum LimitCategoryTypes {
	GAMES = "games",
	SPORTS_BETTING = "sports-betting",
}

export enum LimitTypes {
	LOSS = "loss",
	DEPOSIT = "deposit",
}

export enum MonthlyLimit {
	STAKE_LIMIT = "stake-limit",
	LOSS_LIMIT = "loss-limit-de",
}
